import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { NotificationStatus } from "@/types";

import { CrossEntityNotificationsCountDocument } from "./useCrossEntityNotificationsCount.generated";

// limit must be >= 1 (the backend rejects 0); totalCount is independent of the
// page size, so we request the smallest valid page and read only the count.
gql`
	query CrossEntityNotificationsCount($status: NotificationStatus) {
		account {
			id
			allNotificationsForAttachedEntities(
				statusFilter: $status
				offset: 0
				limit: 1
			) {
				totalCount
			}
		}
	}
`;

/**
 * Counts incomplete notifications across the account and every investing entity
 * it can access. Unlike `useNotificationsQuery`, this is not scoped to the
 * active investing entity, so the bell badge reflects all outstanding work. The
 * count is computed server-side (`totalCount`), so no page of notifications is
 * fetched.
 */
export const useCrossEntityNotificationsCount = ({
	skip = false,
}: { skip?: boolean } = {}): number => {
	const { data } = useQuery(CrossEntityNotificationsCountDocument, {
		variables: { status: NotificationStatus.Incomplete },
		fetchPolicy: "cache-and-network",
		skip,
	});

	return data?.account?.allNotificationsForAttachedEntities.totalCount ?? 0;
};
